/**
 * Game settings update socket hook
 * NOTE: The /system namespace is not available in the gamma-Poker backend.
 * This hook returns a no-op listener to avoid "WebSocket is closed before the
 * connection is established" errors.  Game settings are fetched via REST instead.
 */
const useGameSettingsUpdateSocketNameSpace = () => {
  const listenGameSettingsUpdate = (_cb) => {
    // No-op: /system socket namespace is not registered on the backend
    return () => {}
  }

  return listenGameSettingsUpdate
}

export default useGameSettingsUpdateSocketNameSpace
